import styled from "styled-components";
import logo from "./Group.svg"
import Moon from "./Logo.svg"

const HeaderDiv = styled.div`
  display: inline-flex;
  gap: 0.8rem;
  margin-top: 61px;
  margin-left: 80px;
  img{
    width: 35px;
    height: 40px;
  }
 
`

const HeaderSpan = styled.span`
  font-family: 'Segoe UI';
  font-style: normal;
  font-weight: 700;
  font-size: 25px;
  line-height: 33px;
  color: ${props => props.color };
  
`


const Name = ({isToogle}) => {
    return (
        <HeaderDiv>
            <img src={isToogle ? logo : Moon} />
        <HeaderSpan color={isToogle ? "white" : "black" }>Arthur Gosi </HeaderSpan>
        </HeaderDiv>
    )
}

export default Name